module.exports = __webpack_public_path__ + "static/media/Settings-1.33558471.png";